"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireWildcard(require("ui-box"));

var _theme = require("../../theme");

var animationEasing = {
  spring: "cubic-bezier(0.175, 0.885, 0.320, 1.175)"
};
var handleStyle = {
  backgroundColor: '#fff',
  borderRadius: 9999
};
var iconContainerStyle = {
  transition: "all 500ms ".concat(animationEasing.spring),
  opacity: 0,
  transform: 'scale(0.0)',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 4,
  '&[data-checked="true"]': {
    opacity: 1,
    transform: 'scale(1)'
  }
};
var handleContainerStyle = {
  transition: 'transform 200ms ease-in-out',
  transform: 'translateX(0%)',
  '&[data-checked="true"]': {
    transform: 'translateX(50%)'
  }
};

var CheckIcon = function CheckIcon(_ref) {
  var size = _ref.size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      props = (0, _objectWithoutProperties2.default)(_ref, ["size", "fill"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: 10,
    height: size,
    viewBox: "0 0 10 7"
  }, props), _react.default.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"
  }));
};

CheckIcon.displayName = "CheckIcon";
CheckIcon.propTypes = {
  fill: _propTypes.default.string,
  size: _propTypes.default.number
};

var isControlled = function isControlled(component) {
  return {}.hasOwnProperty.call(component.props, 'checked');
};

var Switch =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Switch, _PureComponent);

  function Switch(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Switch);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Switch).call(this, props, context));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (value) {
      if (isControlled((0, _assertThisInitialized2.default)(_this))) {
        _this.props.onChange(value);
      } else {
        _this.setState(function (_ref2) {
          var checked = _ref2.checked;
          return {
            checked: !checked
          };
        });

        _this.props.onChange(value);
      }
    });
    _this.state = {
      checked: props.checked || props.defaultChecked || false
    };
    return _this;
  }

  (0, _createClass2.default)(Switch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          id = _this$props.id,
          name = _this$props.name,
          height = _this$props.height,
          checkedProps = _this$props.checked,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          appearance = _this$props.appearance,
          hasCheckIcon = _this$props.hasCheckIcon,
          defaultChecked = _this$props.defaultChecked,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "id", "name", "height", "checked", "onChange", "disabled", "appearance", "hasCheckIcon", "defaultChecked"]);
      var checked = isControlled(this) ? checkedProps : this.state.checked;
      var themedClassName = theme.getSwitchClassName(appearance);
      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({
        is: "label",
        display: "block",
        width: height * 2,
        position: "relative"
      }, props), _react.default.createElement(_uiBox.default, {
        is: "input",
        className: themedClassName,
        id: id,
        name: name,
        type: "checkbox",
        checked: checked,
        disabled: disabled,
        defaultChecked: defaultChecked,
        onChange: this.handleChange
      }), _react.default.createElement(_uiBox.default, {
        onClick: this.handleClick,
        height: height,
        width: height * 2
      }, _react.default.createElement(_uiBox.default, {
        height: height,
        width: height,
        "data-checked": checked,
        css: iconContainerStyle
      }, hasCheckIcon && _react.default.createElement(CheckIcon, {
        size: height / 2 - 3
      })), _react.default.createElement(_uiBox.default, {
        width: height * 2,
        display: "flex",
        "data-checked": checked,
        css: handleContainerStyle
      }, _react.default.createElement(_uiBox.default, {
        flex: 1,
        padding: 2
      }, _react.default.createElement(_uiBox.default, {
        width: height - 4,
        height: height - 4,
        css: handleStyle
      })))));
    }
  }]);
  return Switch;
}(_react.PureComponent);

Switch.displayName = "Switch";
(0, _defineProperty2.default)(Switch, "propTypes", (0, _objectSpread2.default)({}, _uiBox.spacing.propTypes, _uiBox.position.propTypes, _uiBox.layout.propTypes, {
  /**
   * The id attribute of the radio.
   */
  id: _propTypes.default.string,

  /**
   * The name attribute of the radio.
   */
  name: _propTypes.default.string,

  /**
   * The value attribute of the radio.
   */
  value: _propTypes.default.string,

  /**
   * The height of the switch.
   */
  height: _propTypes.default.number,

  /**
   * When true, the switch is checked (on).
   */
  checked: _propTypes.default.bool,

  /**
   * Function called when state changes.
   */
  onChange: _propTypes.default.func,

  /**
   * When true, the switch is disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * When true, the switch is invalid.
   */
  isInvalid: _propTypes.default.bool,

  /**
   * The appearance of the checkbox.
   * The default theme only comes with a default style.
   */
  appearance: _propTypes.default.string.isRequired,

  /**
   * When true, the switch has a check icon.
   */
  hasCheckIcon: _propTypes.default.bool,

  /**
   * When true, the switch is true by default.
   * This is for uncontrolled usage.
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired
}));
(0, _defineProperty2.default)(Switch, "defaultProps", {
  height: 16,
  onChange: function onChange() {},
  appearance: 'default',
  hasCheckIcon: true,
  disabled: false
});

var _default = (0, _theme.withTheme)(Switch);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zd2l0Y2gvc3JjL1N3aXRjaC5qcyJdLCJuYW1lcyI6WyJhbmltYXRpb25FYXNpbmciLCJzcHJpbmciLCJoYW5kbGVTdHlsZSIsImJhY2tncm91bmRDb2xvciIsImJvcmRlclJhZGl1cyIsImljb25Db250YWluZXJTdHlsZSIsInRyYW5zaXRpb24iLCJvcGFjaXR5IiwidHJhbnNmb3JtIiwiZGlzcGxheSIsInBvc2l0aW9uIiwiYWxpZ25JdGVtcyIsImp1c3RpZnlDb250ZW50IiwicGFkZGluZ0xlZnQiLCJoYW5kbGVDb250YWluZXJTdHlsZSIsIkNoZWNrSWNvbiIsInNpemUiLCJmaWxsIiwicHJvcHMiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJzdHJpbmciLCJudW1iZXIiLCJpc0NvbnRyb2xsZWQiLCJjb21wb25lbnQiLCJoYXNPd25Qcm9wZXJ0eSIsImNhbGwiLCJTd2l0Y2giLCJjb250ZXh0IiwidmFsdWUiLCJvbkNoYW5nZSIsInNldFN0YXRlIiwiY2hlY2tlZCIsInN0YXRlIiwiZGVmYXVsdENoZWNrZWQiLCJ0aGVtZSIsImlkIiwibmFtZSIsImhlaWdodCIsImNoZWNrZWRQcm9wcyIsImRpc2FibGVkIiwiYXBwZWFyYW5jZSIsImhhc0NoZWNrSWNvbiIsInRoZW1lZENsYXNzTmFtZSIsImdldFN3aXRjaENsYXNzTmFtZSIsImhhbmRsZUNoYW5nZSIsImhhbmRsZUNsaWNrIiwiUHVyZUNvbXBvbmVudCIsInNwYWNpbmciLCJsYXlvdXQiLCJib29sIiwiZnVuYyIsImlzSW52YWxpZCIsImlzUmVxdWlyZWQiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFFQSxJQUFNQSxlQUFlLEdBQUc7QUFDdEJDLEVBQUFBLE1BQU07QUFEZ0IsQ0FBeEI7QUFJQSxJQUFNQyxXQUFXLEdBQUc7QUFDbEJDLEVBQUFBLGVBQWUsRUFBRSxNQURDO0FBRWxCQyxFQUFBQSxZQUFZLEVBQUU7QUFGSSxDQUFwQjtBQUtBLElBQU1DLGtCQUFrQixHQUFHO0FBQ3pCQyxFQUFBQSxVQUFVLHNCQUFlTixlQUFlLENBQUNDLE1BQS9CLENBRGU7QUFFekJNLEVBQUFBLE9BQU8sRUFBRSxDQUZnQjtBQUd6QkMsRUFBQUEsU0FBUyxFQUFFLFlBSGM7QUFJekJDLEVBQUFBLE9BQU8sRUFBRSxNQUpnQjtBQUt6QkMsRUFBQUEsUUFBUSxFQUFFLFVBTGU7QUFNekJDLEVBQUFBLFVBQVUsRUFBRSxRQU5hO0FBT3pCQyxFQUFBQSxjQUFjLEVBQUUsUUFQUztBQVF6QkMsRUFBQUEsV0FBVyxFQUFFLENBUlk7QUFTekIsNEJBQTBCO0FBQ3hCTixJQUFBQSxPQUFPLEVBQUUsQ0FEZTtBQUV4QkMsSUFBQUEsU0FBUyxFQUFFO0FBRmE7QUFURCxDQUEzQjtBQWVBLElBQU1NLG9CQUFvQixHQUFHO0FBQzNCUixFQUFBQSxVQUFVLEVBQUUsNkJBRGU7QUFFM0JFLEVBQUFBLFNBQVMsRUFBRSxnQkFGZ0I7QUFHM0IsNEJBQTBCO0FBQ3hCQSxJQUFBQSxTQUFTLEVBQUU7QUFEYTtBQUhDLENBQTdCOztBQVFBLElBQU1PLFNBQVMsR0FBRyxTQUFaQSxTQUFZO0FBQUEsTUFBR0MsSUFBSCxRQUFHQSxJQUFIO0FBQUEsdUJBQVNDLElBQVQ7QUFBQSxNQUFTQSxJQUFULDBCQUFnQixjQUFoQjtBQUFBLE1BQW1DQyxLQUFuQztBQUFBLFNBQ2hCO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRUYsSUFBeEI7QUFBOEIsSUFBQSxPQUFPLEVBQUM7QUFBdEMsS0FBcURFLEtBQXJELEdBQ0U7QUFDRSxJQUFBLElBQUksRUFBRUQsSUFEUjtBQUVFLElBQUEsUUFBUSxFQUFDLFNBRlg7QUFHRSxJQUFBLENBQUMsRUFBQztBQUhKLElBREYsQ0FEZ0I7QUFBQSxDQUFsQjs7QUFBTUYsUztBQVVOQSxTQUFTLENBQUNJLFNBQVYsR0FBc0I7QUFDcEJGLEVBQUFBLElBQUksRUFBRUcsbUJBQVVDLE1BREk7QUFFcEJMLEVBQUFBLElBQUksRUFBRUksbUJBQVVFO0FBRkksQ0FBdEI7O0FBS0EsSUFBTUMsWUFBWSxHQUFHLFNBQWZBLFlBQWUsQ0FBQUMsU0FBUyxFQUFJO0FBQ2hDLFNBQU8sR0FBR0MsY0FBSCxDQUFrQkMsSUFBbEIsQ0FBdUJGLFNBQVMsQ0FBQ04sS0FBakMsRUFBd0MsU0FBeEMsQ0FBUDtBQUNELENBRkQ7O0lBSU1TLE07Ozs7O0FBZ0ZKLGtCQUFZVCxLQUFaLEVBQW1CVSxPQUFuQixFQUE0QjtBQUFBOztBQUFBO0FBQzFCLDRHQUFNVixLQUFOLEVBQWFVLE9BQWI7QUFEMEIsK0ZBT2IsVUFBQUMsS0FBSyxFQUFJO0FBQ3RCLFVBQUlOLFlBQVksNkNBQWhCLEVBQXdCO0FBQ3RCLGNBQUtMLEtBQUwsQ0FBV1ksUUFBWCxDQUFvQkQsS0FBcEI7QUFDRCxPQUZELE1BRU87QUFDTCxjQUFLRSxRQUFMLENBQWM7QUFBQSxjQUFHQyxPQUFILFNBQUdBLE9BQUg7QUFBQSxpQkFBa0I7QUFDOUJBLFlBQUFBLE9BQU8sRUFBRSxDQUFDQTtBQURvQixXQUFsQjtBQUFBLFNBQWQ7O0FBR0EsY0FBS2QsS0FBTCxDQUFXWSxRQUFYLENBQW9CRCxLQUFwQjtBQUNEO0FBQ0YsS0FoQjJCO0FBRTFCLFVBQUtJLEtBQUwsR0FBYTtBQUNYRCxNQUFBQSxPQUFPLEVBQUVkLEtBQUssQ0FBQ2MsT0FBTixJQUFpQmQsS0FBSyxDQUFDZ0IsY0FBdkIsSUFBeUM7QUFEdkMsS0FBYjtBQUYwQjtBQUszQjs7Ozs2QkFhUTtBQUFBLHdCQWNILEtBQUtoQixLQWRGO0FBQUEsVUFFTGlCLEtBRkssZUFFTEEsS0FGSztBQUFBLFVBSUxDLEVBSkssZUFJTEEsRUFKSztBQUFBLFVBS0xDLElBTEssZUFLTEEsSUFMSztBQUFBLFVBTUxDLE1BTkssZUFNTEEsTUFOSztBQUFBLFVBT0lDLFlBUEosZUFPTFAsT0FQSztBQUFBLFVBUUxGLFFBUkssZUFRTEEsUUFSSztBQUFBLFVBU0xVLFFBVEssZUFTTEEsUUFUSztBQUFBLFVBVUxDLFVBVkssZUFVTEEsVUFWSztBQUFBLFVBV0xDLFlBWEssZUFXTEEsWUFYSztBQUFBLFVBWUxSLGNBWkssZUFZTEEsY0FaSztBQUFBLFVBYUZoQixLQWJFO0FBZ0JQLFVBQU1jLE9BQU8sR0FBR1QsWUFBWSxDQUFDLElBQUQsQ0FBWixHQUFxQmdCLFlBQXJCLEdBQW9DLEtBQUtOLEtBQUwsQ0FBV0QsT0FBL0Q7QUFDQSxVQUFNVyxlQUFlLEdBQUdSLEtBQUssQ0FBQ1Msa0JBQU4sQ0FBeUJILFVBQXpCLENBQXhCO0FBRUEsYUFDRSw2QkFBQyxjQUFEO0FBQ0UsUUFBQSxFQUFFLEVBQUMsT0FETDtBQUVFLFFBQUEsT0FBTyxFQUFDLE9BRlY7QUFHRSxRQUFBLEtBQUssRUFBRUgsTUFBTSxHQUFHLENBSGxCO0FBSUUsUUFBQSxRQUFRLEVBQUM7QUFKWCxTQUtNcEIsS0FMTixHQU9FLDZCQUFDLGNBQUQ7QUFDRSxRQUFBLEVBQUUsRUFBQyxPQURMO0FBRUUsUUFBQSxTQUFTLEVBQUV5QixlQUZiO0FBR0UsUUFBQSxFQUFFLEVBQUVQLEVBSE47QUFJRSxRQUFBLElBQUksRUFBRUMsSUFKUjtBQUtFLFFBQUEsSUFBSSxFQUFDLFVBTFA7QUFNRSxRQUFBLE9BQU8sRUFBRUwsT0FOWDtBQU9FLFFBQUEsUUFBUSxFQUFFUSxRQVBaO0FBUUUsUUFBQSxjQUFjLEVBQUVOLGNBUmxCO0FBU0UsUUFBQSxRQUFRLEVBQUUsS0FBS1c7QUFUakIsUUFQRixFQWtCRSw2QkFBQyxjQUFEO0FBQUssUUFBQSxPQUFPLEVBQUUsS0FBS0MsV0FBbkI7QUFBZ0MsUUFBQSxNQUFNLEVBQUVSLE1BQXhDO0FBQWdELFFBQUEsS0FBSyxFQUFFQSxNQUFNLEdBQUc7QUFBaEUsU0FDRSw2QkFBQyxjQUFEO0FBQ0UsUUFBQSxNQUFNLEVBQUVBLE1BRFY7QUFFRSxRQUFBLEtBQUssRUFBRUEsTUFGVDtBQUdFLHdCQUFjTixPQUhoQjtBQUlFLFFBQUEsR0FBRyxFQUFFM0I7QUFKUCxTQU1HcUMsWUFBWSxJQUFJLDZCQUFDLFNBQUQ7QUFBVyxRQUFBLElBQUksRUFBRUosTUFBTSxHQUFHLENBQVQsR0FBYTtBQUE5QixRQU5uQixDQURGLEVBU0UsNkJBQUMsY0FBRDtBQUNFLFFBQUEsS0FBSyxFQUFFQSxNQUFNLEdBQUcsQ0FEbEI7QUFFRSxRQUFBLE9BQU8sRUFBQyxNQUZWO0FBR0Usd0JBQWNOLE9BSGhCO0FBSUUsUUFBQSxHQUFHLEVBQUVsQjtBQUpQLFNBTUUsNkJBQUMsY0FBRDtBQUFLLFFBQUEsSUFBSSxFQUFFLENBQVg7QUFBYyxRQUFBLE9BQU8sRUFBRTtBQUF2QixTQUNFLDZCQUFDLGNBQUQ7QUFBSyxRQUFBLEtBQUssRUFBRXdCLE1BQU0sR0FBRyxDQUFyQjtBQUF3QixRQUFBLE1BQU0sRUFBRUEsTUFBTSxHQUFHLENBQXpDO0FBQTRDLFFBQUEsR0FBRyxFQUFFcEM7QUFBakQsUUFERixDQU5GLENBVEYsQ0FsQkYsQ0FERjtBQXlDRDs7O0VBOUprQjZDLG9COztBQUFmcEIsTTs4QkFBQUEsTSwrQ0FLQ3FCLGVBQVE3QixTLEVBQ1JULGdCQUFTUyxTLEVBQ1Q4QixjQUFPOUIsUztBQUVWOzs7QUFHQWlCLEVBQUFBLEVBQUUsRUFBRWhCLG1CQUFVQyxNOztBQUVkOzs7QUFHQWdCLEVBQUFBLElBQUksRUFBRWpCLG1CQUFVQyxNOztBQUVoQjs7O0FBR0FRLEVBQUFBLEtBQUssRUFBRVQsbUJBQVVDLE07O0FBRWpCOzs7QUFHQWlCLEVBQUFBLE1BQU0sRUFBRWxCLG1CQUFVRSxNOztBQUVsQjs7O0FBR0FVLEVBQUFBLE9BQU8sRUFBRVosbUJBQVU4QixJOztBQUVuQjs7O0FBR0FwQixFQUFBQSxRQUFRLEVBQUVWLG1CQUFVK0IsSTs7QUFFcEI7OztBQUdBWCxFQUFBQSxRQUFRLEVBQUVwQixtQkFBVThCLEk7O0FBRXBCOzs7QUFHQUUsRUFBQUEsU0FBUyxFQUFFaEMsbUJBQVU4QixJOztBQUVyQjs7OztBQUlBVCxFQUFBQSxVQUFVLEVBQUVyQixtQkFBVUMsTUFBVixDQUFpQmdDLFU7O0FBRTdCOzs7QUFHQVgsRUFBQUEsWUFBWSxFQUFFdEIsbUJBQVU4QixJOztBQUV4Qjs7OztBQUlBaEIsRUFBQUEsY0FBYyxFQUFFZCxtQkFBVThCLEk7O0FBRTFCOzs7QUFHQWYsRUFBQUEsS0FBSyxFQUFFZixtQkFBVWtDLE1BQVYsQ0FBaUJEOzs4QkFyRXRCMUIsTSxrQkF3RWtCO0FBQ3BCVyxFQUFBQSxNQUFNLEVBQUUsRUFEWTtBQUVwQlIsRUFBQUEsUUFBUSxFQUFFLG9CQUFNLENBQUUsQ0FGRTtBQUdwQlcsRUFBQUEsVUFBVSxFQUFFLFNBSFE7QUFJcEJDLEVBQUFBLFlBQVksRUFBRSxJQUpNO0FBS3BCRixFQUFBQSxRQUFRLEVBQUU7QUFMVSxDOztlQXlGVCxzQkFBVWIsTUFBVixDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCBCb3gsIHsgc3BhY2luZywgcG9zaXRpb24sIGxheW91dCB9IGZyb20gJ3VpLWJveCdcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJy4uLy4uL3RoZW1lJ1xuXG5jb25zdCBhbmltYXRpb25FYXNpbmcgPSB7XG4gIHNwcmluZzogYGN1YmljLWJlemllcigwLjE3NSwgMC44ODUsIDAuMzIwLCAxLjE3NSlgXG59XG5cbmNvbnN0IGhhbmRsZVN0eWxlID0ge1xuICBiYWNrZ3JvdW5kQ29sb3I6ICcjZmZmJyxcbiAgYm9yZGVyUmFkaXVzOiA5OTk5XG59XG5cbmNvbnN0IGljb25Db250YWluZXJTdHlsZSA9IHtcbiAgdHJhbnNpdGlvbjogYGFsbCA1MDBtcyAke2FuaW1hdGlvbkVhc2luZy5zcHJpbmd9YCxcbiAgb3BhY2l0eTogMCxcbiAgdHJhbnNmb3JtOiAnc2NhbGUoMC4wKScsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gIGFsaWduSXRlbXM6ICdjZW50ZXInLFxuICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG4gIHBhZGRpbmdMZWZ0OiA0LFxuICAnJltkYXRhLWNoZWNrZWQ9XCJ0cnVlXCJdJzoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNmb3JtOiAnc2NhbGUoMSknXG4gIH1cbn1cblxuY29uc3QgaGFuZGxlQ29udGFpbmVyU3R5bGUgPSB7XG4gIHRyYW5zaXRpb246ICd0cmFuc2Zvcm0gMjAwbXMgZWFzZS1pbi1vdXQnLFxuICB0cmFuc2Zvcm06ICd0cmFuc2xhdGVYKDAlKScsXG4gICcmW2RhdGEtY2hlY2tlZD1cInRydWVcIl0nOiB7XG4gICAgdHJhbnNmb3JtOiAndHJhbnNsYXRlWCg1MCUpJ1xuICB9XG59XG5cbmNvbnN0IENoZWNrSWNvbiA9ICh7IHNpemUsIGZpbGwgPSAnY3VycmVudENvbG9yJywgLi4ucHJvcHMgfSkgPT4gKFxuICA8c3ZnIHdpZHRoPXsxMH0gaGVpZ2h0PXtzaXplfSB2aWV3Qm94PVwiMCAwIDEwIDdcIiB7Li4ucHJvcHN9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPXtmaWxsfVxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGQ9XCJNNCA0LjU4NkwxLjcwNyAyLjI5M0ExIDEgMCAxIDAgLjI5MyAzLjcwN2wzIDNhLjk5Ny45OTcgMCAwIDAgMS40MTQgMGw1LTVBMSAxIDAgMSAwIDguMjkzLjI5M0w0IDQuNTg2elwiXG4gICAgLz5cbiAgPC9zdmc+XG4pXG5cbkNoZWNrSWNvbi5wcm9wVHlwZXMgPSB7XG4gIGZpbGw6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHNpemU6IFByb3BUeXBlcy5udW1iZXJcbn1cblxuY29uc3QgaXNDb250cm9sbGVkID0gY29tcG9uZW50ID0+IHtcbiAgcmV0dXJuIHt9Lmhhc093blByb3BlcnR5LmNhbGwoY29tcG9uZW50LnByb3BzLCAnY2hlY2tlZCcpXG59XG5cbmNsYXNzIFN3aXRjaCBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC8qKlxuICAgICAqIENvbXBvc2VzIHNvbWUgQm94IEFQSXMuXG4gICAgICovXG4gICAgLi4uc3BhY2luZy5wcm9wVHlwZXMsXG4gICAgLi4ucG9zaXRpb24ucHJvcFR5cGVzLFxuICAgIC4uLmxheW91dC5wcm9wVHlwZXMsXG5cbiAgICAvKipcbiAgICAgKiBUaGUgaWQgYXR0cmlidXRlIG9mIHRoZSByYWRpby5cbiAgICAgKi9cbiAgICBpZDogUHJvcFR5cGVzLnN0cmluZyxcblxuICAgIC8qKlxuICAgICAqIFRoZSBuYW1lIGF0dHJpYnV0ZSBvZiB0aGUgcmFkaW8uXG4gICAgICovXG4gICAgbmFtZTogUHJvcFR5cGVzLnN0cmluZyxcblxuICAgIC8qKlxuICAgICAqIFRoZSB2YWx1ZSBhdHRyaWJ1dGUgb2YgdGhlIHJhZGlvLlxuICAgICAqL1xuICAgIHZhbHVlOiBQcm9wVHlwZXMuc3RyaW5nLFxuXG4gICAgLyoqXG4gICAgICogVGhlIGhlaWdodCBvZiB0aGUgc3dpdGNoLlxuICAgICAqL1xuICAgIGhlaWdodDogUHJvcFR5cGVzLm51bWJlcixcblxuICAgIC8qKlxuICAgICAqIFdoZW4gdHJ1ZSwgdGhlIHN3aXRjaCBpcyBjaGVja2VkIChvbikuXG4gICAgICovXG4gICAgY2hlY2tlZDogUHJvcFR5cGVzLmJvb2wsXG5cbiAgICAvKipcbiAgICAgKiBGdW5jdGlvbiBjYWxsZWQgd2hlbiBzdGF0ZSBjaGFuZ2VzLlxuICAgICAqL1xuICAgIG9uQ2hhbmdlOiBQcm9wVHlwZXMuZnVuYyxcblxuICAgIC8qKlxuICAgICAqIFdoZW4gdHJ1ZSwgdGhlIHN3aXRjaCBpcyBkaXNhYmxlZC5cbiAgICAgKi9cbiAgICBkaXNhYmxlZDogUHJvcFR5cGVzLmJvb2wsXG5cbiAgICAvKipcbiAgICAgKiBXaGVuIHRydWUsIHRoZSBzd2l0Y2ggaXMgaW52YWxpZC5cbiAgICAgKi9cbiAgICBpc0ludmFsaWQ6IFByb3BUeXBlcy5ib29sLFxuXG4gICAgLyoqXG4gICAgICogVGhlIGFwcGVhcmFuY2Ugb2YgdGhlIGNoZWNrYm94LlxuICAgICAqIFRoZSBkZWZhdWx0IHRoZW1lIG9ubHkgY29tZXMgd2l0aCBhIGRlZmF1bHQgc3R5bGUuXG4gICAgICovXG4gICAgYXBwZWFyYW5jZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuXG4gICAgLyoqXG4gICAgICogV2hlbiB0cnVlLCB0aGUgc3dpdGNoIGhhcyBhIGNoZWNrIGljb24uXG4gICAgICovXG4gICAgaGFzQ2hlY2tJY29uOiBQcm9wVHlwZXMuYm9vbCxcblxuICAgIC8qKlxuICAgICAqIFdoZW4gdHJ1ZSwgdGhlIHN3aXRjaCBpcyB0cnVlIGJ5IGRlZmF1bHQuXG4gICAgICogVGhpcyBpcyBmb3IgdW5jb250cm9sbGVkIHVzYWdlLlxuICAgICAqL1xuICAgIGRlZmF1bHRDaGVja2VkOiBQcm9wVHlwZXMuYm9vbCxcblxuICAgIC8qKlxuICAgICAqIFRoZW1lIHByb3ZpZGVkIGJ5IFRoZW1lUHJvdmlkZXIuXG4gICAgICovXG4gICAgdGhlbWU6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZFxuICB9XG5cbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBoZWlnaHQ6IDE2LFxuICAgIG9uQ2hhbmdlOiAoKSA9PiB7fSxcbiAgICBhcHBlYXJhbmNlOiAnZGVmYXVsdCcsXG4gICAgaGFzQ2hlY2tJY29uOiB0cnVlLFxuICAgIGRpc2FibGVkOiBmYWxzZVxuICB9XG5cbiAgY29uc3RydWN0b3IocHJvcHMsIGNvbnRleHQpIHtcbiAgICBzdXBlcihwcm9wcywgY29udGV4dClcbiAgICB0aGlzLnN0YXRlID0ge1xuICAgICAgY2hlY2tlZDogcHJvcHMuY2hlY2tlZCB8fCBwcm9wcy5kZWZhdWx0Q2hlY2tlZCB8fCBmYWxzZVxuICAgIH1cbiAgfVxuXG4gIGhhbmRsZUNoYW5nZSA9IHZhbHVlID0+IHtcbiAgICBpZiAoaXNDb250cm9sbGVkKHRoaXMpKSB7XG4gICAgICB0aGlzLnByb3BzLm9uQ2hhbmdlKHZhbHVlKVxuICAgIH0gZWxzZSB7XG4gICAgICB0aGlzLnNldFN0YXRlKCh7IGNoZWNrZWQgfSkgPT4gKHtcbiAgICAgICAgY2hlY2tlZDogIWNoZWNrZWRcbiAgICAgIH0pKVxuICAgICAgdGhpcy5wcm9wcy5vbkNoYW5nZSh2YWx1ZSlcbiAgICB9XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3Qge1xuICAgICAgdGhlbWUsXG5cbiAgICAgIGlkLFxuICAgICAgbmFtZSxcbiAgICAgIGhlaWdodCxcbiAgICAgIGNoZWNrZWQ6IGNoZWNrZWRQcm9wcyxcbiAgICAgIG9uQ2hhbmdlLFxuICAgICAgZGlzYWJsZWQsXG4gICAgICBhcHBlYXJhbmNlLFxuICAgICAgaGFzQ2hlY2tJY29uLFxuICAgICAgZGVmYXVsdENoZWNrZWQsXG4gICAgICAuLi5wcm9wc1xuICAgIH0gPSB0aGlzLnByb3BzXG5cbiAgICBjb25zdCBjaGVja2VkID0gaXNDb250cm9sbGVkKHRoaXMpID8gY2hlY2tlZFByb3BzIDogdGhpcy5zdGF0ZS5jaGVja2VkXG4gICAgY29uc3QgdGhlbWVkQ2xhc3NOYW1lID0gdGhlbWUuZ2V0U3dpdGNoQ2xhc3NOYW1lKGFwcGVhcmFuY2UpXG5cbiAgICByZXR1cm4gKFxuICAgICAgPEJveFxuICAgICAgICBpcz1cImxhYmVsXCJcbiAgICAgICAgZGlzcGxheT1cImJsb2NrXCJcbiAgICAgICAgd2lkdGg9e2hlaWdodCAqIDJ9XG4gICAgICAgIHBvc2l0aW9uPVwicmVsYXRpdmVcIlxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICA+XG4gICAgICAgIDxCb3hcbiAgICAgICAgICBpcz1cImlucHV0XCJcbiAgICAgICAgICBjbGFzc05hbWU9e3RoZW1lZENsYXNzTmFtZX1cbiAgICAgICAgICBpZD17aWR9XG4gICAgICAgICAgbmFtZT17bmFtZX1cbiAgICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICAgIGNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICAgICAgZGlzYWJsZWQ9e2Rpc2FibGVkfVxuICAgICAgICAgIGRlZmF1bHRDaGVja2VkPXtkZWZhdWx0Q2hlY2tlZH1cbiAgICAgICAgICBvbkNoYW5nZT17dGhpcy5oYW5kbGVDaGFuZ2V9XG4gICAgICAgIC8+XG4gICAgICAgIDxCb3ggb25DbGljaz17dGhpcy5oYW5kbGVDbGlja30gaGVpZ2h0PXtoZWlnaHR9IHdpZHRoPXtoZWlnaHQgKiAyfT5cbiAgICAgICAgICA8Qm94XG4gICAgICAgICAgICBoZWlnaHQ9e2hlaWdodH1cbiAgICAgICAgICAgIHdpZHRoPXtoZWlnaHR9XG4gICAgICAgICAgICBkYXRhLWNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICAgICAgICBjc3M9e2ljb25Db250YWluZXJTdHlsZX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7aGFzQ2hlY2tJY29uICYmIDxDaGVja0ljb24gc2l6ZT17aGVpZ2h0IC8gMiAtIDN9IC8+fVxuICAgICAgICAgIDwvQm94PlxuICAgICAgICAgIDxCb3hcbiAgICAgICAgICAgIHdpZHRoPXtoZWlnaHQgKiAyfVxuICAgICAgICAgICAgZGlzcGxheT1cImZsZXhcIlxuICAgICAgICAgICAgZGF0YS1jaGVja2VkPXtjaGVja2VkfVxuICAgICAgICAgICAgY3NzPXtoYW5kbGVDb250YWluZXJTdHlsZX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICA8Qm94IGZsZXg9ezF9IHBhZGRpbmc9ezJ9PlxuICAgICAgICAgICAgICA8Qm94IHdpZHRoPXtoZWlnaHQgLSA0fSBoZWlnaHQ9e2hlaWdodCAtIDR9IGNzcz17aGFuZGxlU3R5bGV9IC8+XG4gICAgICAgICAgICA8L0JveD5cbiAgICAgICAgICA8L0JveD5cbiAgICAgICAgPC9Cb3g+XG4gICAgICA8L0JveD5cbiAgICApXG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgd2l0aFRoZW1lKFN3aXRjaClcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/switch/src/Switch.js
// module id = 199
// module chunks = 0